<template>
  <span class="switch" :style="width ? `width: ${width}` : ''">
    <div :class="['switch__container', { actived: value, loading }]">
      <span class="switch__dot"></span>
    </div>
    <input
      :class="['switch__input', { loading: loading }]"
      type="checkbox"
      :value="value"
      @change.prevent="$emit('change', !value)"
    />
  </span>
</template>

<script>
export default {
  name: 'SwitchBtn',
  props: {
    value: { type: Boolean, required: true },
    width: { type: String, required: false, default: null },
    loading: { type: Boolean, required: false },
  },
};
</script>

<style lang="scss" scoped>
@import './style.scss';
</style>
